/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/

/* Polyfill
 ----------------------------------------------------------*/
import './polyfill/_assign'
import './polyfill/_for-each'

/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "modules/_navigation";
import ObjectFit from "modules/_object-fit";
import Print from "modules/_print";
import LazyLoad from "modules/_lazy-load";
import SocialShare from "./modules/_social-share";
import Articles from "./modules/_articles";
import ComparisonWidget from "./modules/_comparison-widget";
import SmoothScroll from "./modules/_smooth-scroll";
import AccordionWidget from "./modules/_accordion-widget";
import VideoModal from "./modules/_video-modal";
import FAQSchema from "./modules/_faq-schema-widget";
import ScrollDownButtons from "./modules/_scroll-down";
import MobileSubmenu from "./modules/_mobile-submenu";
import Modal from "./modules/_modal";
import ContactTracking from "./modules/_contact-tracking";
import OpeningHours from "./modules/_opening-hours";
import EnhancedConversions from './modules/_enhanced-conversions'
import SlideToggle from './modules/_slide-toggle'
import ExplicitContent from 'modules/_explicit-content'

/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(LazyLoad);
app.use(ScrollDownButtons);
app.use(SocialShare);
app.use(Articles);
app.use(ComparisonWidget);
app.use(SmoothScroll);
app.use(AccordionWidget);
app.use(VideoModal);
app.use(FAQSchema);
app.use(MobileSubmenu);
app.use(Modal);
app.use(ContactTracking);
app.use(OpeningHours);
app.use(EnhancedConversions);
app.use(ExplicitContent);
SlideToggle();

require('./app');